import {Component, Prop, Vue} from 'vue-property-decorator'
import {ActiveInject} from "@/support/reactive"

@Component
export default class AnalyticsEmitterMixin extends Vue {

    @ActiveInject({from: 'jds.analytics'}) $analyticsBus!: Vue;

    /**
     * A way to identify this instance of this component's usage within the app. For example,
     * `track="jobilla.ats.candidate.send-email"` will identify this butt as the Jobilla ATS
     * candidate email sending button.
     *
     * **If no `track` is set, events on a particular component instance will not emit analytics.**
     */
    @Prop({type: String, default: ''}) track!: string;

    /**
     * If you can identify this particular instance of the component, for example the candidate ID
     * which you're looking at right now, you can attach this to further identify the analytics events.
     * Completely optional.
     */
    @Prop({type: String}) trackResource!: string;

    $analytics(event: string, extra: {[s: string]: any} = {}) {
        if (!this.track) return

        this.$analyticsBus.$emit('event', {
            track: this.track,
            ...(this.trackResource !== undefined && {resource: this.trackResource}),
            ... extra,
            event,
        })
    }

}
